import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, Phone, Mail, MapPin, Shield } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 text-slate-400 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-amber-500 text-slate-950 flex items-center justify-center font-extrabold">
                <Scale className="w-5 h-5" />
              </div>
              <span className="text-lg font-bold text-slate-100">ELUM LAW</span>
            </div>
            <p className="text-xs text-slate-400 leading-relaxed mb-4">
              International-Standard Law Firm Platform in Pakistan providing legal representation, statutory search, and AI assistant solutions.
            </p>
            <div className="flex items-center gap-2 text-xs text-amber-400 font-medium">
              <Shield className="w-4 h-4" /> 100% Leakage-Proof Compliance
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-slate-200 uppercase tracking-wider mb-4">Platform Navigation</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/" className="hover:text-amber-400">Home Portal</Link></li>
              <li><Link to="/dashboard" className="hover:text-amber-400">Role Dashboard</Link></li>
              <li><Link to="/lawyers" className="hover:text-amber-400">Find a Lawyer</Link></li>
              <li><Link to="/law-directory" className="hover:text-amber-400">Pakistan Law Directory</Link></li>
              <li><Link to="/pricing" className="hover:text-amber-400">Subscription Plans</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-slate-200 uppercase tracking-wider mb-4">Practice Areas</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/legal-practices" className="hover:text-amber-400">Constitutional Writs</Link></li>
              <li><Link to="/legal-practices" className="hover:text-amber-400">Service Tribunal Appeals</Link></li>
              <li><Link to="/legal-practices" className="hover:text-amber-400">Corporate & Tax Litigation</Link></li>
              <li><Link to="/legal-practices" className="hover:text-amber-400">Property & Title Verification</Link></li>
              <li><Link to="/legal-practices" className="hover:text-amber-400">NAB & Criminal Defense</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-slate-200 uppercase tracking-wider mb-4">Headquarters Contact</h4>
            <div className="space-y-3 text-xs">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
                <span>Suite 402, Executive Law Chambers, Blue Area, Islamabad</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-amber-400 shrink-0" />
                <span>+92 51 111 358 600</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-amber-400 shrink-0" />
                <span>contact@elumlaw.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-900 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500 gap-4">
          <p>© {new Date().getFullYear()} Elum Law Associates Pakistan. All Rights Reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/terms" className="hover:text-slate-400">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-slate-400">Privacy Policy</Link>
            <Link to="/faq" className="hover:text-slate-400">Help & FAQ</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
